import { useSpawnParticipantCall } from 'features/call/call-accepted/hooks';
import { ChangePhoneNumber } from 'features/call/call-details/components';
import { useValidatePhoneNumberInput } from 'features/phone-number/hooks';

export const ChangePhoneNumberContainer = () => {
  const { handleSpawnNewCall } = useSpawnParticipantCall();
  const { ref, isPhoneNumberValid, unmaskedValue } =
    useValidatePhoneNumberInput();

  return (
    <ChangePhoneNumber
      refPhoneNumber={ref}
      isPhoneNumberValid={isPhoneNumberValid}
      onClick={() => handleSpawnNewCall(unmaskedValue)}
    />
  );
};
